export default "__VITE_ASSET__D1ZuVKEO__"